// extracted by mini-css-extract-plugin
module.exports = {"chat":"ChatbotLenkepanel_chat__Y2uN4"};